module.exports = __webpack_public_path__ + "static/media/rss-symbol.dce7286a.svg";